import React, { useEffect, useState } from 'react'

import Button from '../button'
import Typography from '../typography'
import { BlogFeaturedResourceContainer } from './style'

import { generateAdData } from '../../../utils/functions.utils'
import WrapperImage from '../wrapperImage'

const BlogFeaturedResource = (props: any) => {
  const [data, setData] = useState<any>(null)
  const featuredResource = props.data

  useEffect(() => {
    if (featuredResource) {
      setData(generateAdData(featuredResource))
    }
  }, [])
  const hasImage = data && data.image ? true : false
  return (
    data && (
      <BlogFeaturedResourceContainer data-cy="BlogFeaturedResource" $hasImage={hasImage}>
        <div>
          {data.image && (
            <WrapperImage
              src={data.image}
              alt={data.imageAlt}
              width={540}
              height={544}
              threshold={650}
            />
          )}
          {data.category && (
            <Typography className="BlogFeaturedResource__Category" type="caption">
              {data.category}
            </Typography>
          )}
          {data.title && (
            <Typography className="BlogFeaturedResource__Title" type="header6">
              {data.title}
            </Typography>
          )}

          {data.body && (
            <Typography className="BlogFeaturedResource__Body" type="body">
              {data.body}
            </Typography>
          )}

          {data.ctaText && data.ctaUrl && (
            <Button
              icon={true}
              href={data.ctaUrl}
              text={data.ctaText}
              type="primary"
              size="small"
              theme={'dark'}
            />
          )}
        </div>
      </BlogFeaturedResourceContainer>
    )
  )
}

export default BlogFeaturedResource
